// src/hooks/useAuth.js
// import { useState, useEffect } from "react";
// import { supabase } from "../supabaseClient";

// export const useAuth = () => {
//   const [loading, setLoading] = useState(true);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   const checkAuthStatus = async () => {
//     try {
//       const { data: { session }, error } = await supabase.auth.getSession();

//       if (error) {
//         console.error("Error checking auth status:", error);
//         setIsAuthenticated(false);
//         return;
//       }

//       // Verify the session is still valid
//       if (session) {
//         const { data: { user }, error: userError } = await supabase.auth.getUser();
//         if (userError || !user) {
//           setIsAuthenticated(false);
//           return;
//         }
//       }

//       setIsAuthenticated(!!session);
//     } catch (err) {
//       console.error("Unexpected error checking auth:", err);
//       setIsAuthenticated(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     checkAuthStatus();

//     // Listen to auth changes (login/logout)
//     const { data: authListener } = supabase.auth.onAuthStateChange(
//       async (_event, session) => {
//         await checkAuthStatus();
//       }
//     );

//     // Clean up the listener
//     return () => {
//       authListener?.subscription?.unsubscribe();
//     };
//   }, []);

//   return { isAuthenticated, loading };
// };




// import { useState, useEffect } from "react";
// import { supabase } from "../supabaseClient";

// export const useAuth = () => {
//   const [loading, setLoading] = useState(true);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const checkAuthStatus = async () => {
//       const {
//         data: { session },
//       } = await supabase.auth.getSession();
//       setIsAuthenticated(!!session);
//       setLoading(false);
//     };

//     checkAuthStatus();

//     // Listen to auth changes (login/logout)
//     const { data: authListener } = supabase.auth.onAuthStateChange(
//       (_event, session) => {
//         setIsAuthenticated(!!session);
//         setLoading(false);
//       }
//     );

//     // Clean up the listener
//     return () => {
//       authListener?.subscription?.unsubscribe(); // Safely check if unsubscribe exists
//     };
//   }, []);

//   return { isAuthenticated, loading };
// };



import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

export const useAuth = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setIsAuthenticated(!!session);
      if (session?.user) {
        // Assume user_type is stored in user_metadata
        setUserType(session.user.user_metadata?.role || null);
      } else {
        setUserType(null);
      }
      setLoading(false);
    };

    checkAuthStatus();

    const { data: authListener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setIsAuthenticated(!!session);
        if (session?.user) {
          setUserType(session.user.user_metadata?.role || null);
        } else {
          setUserType(null);
        }
        setLoading(false);
      }
    );

    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  return { isAuthenticated, loading, userType };
};